import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import axios from "axios";
import { Box, LinearProgress, Tooltip } from "@mui/material";
import { Form, Button, Card } from "react-bootstrap";
import Modal from "@mui/material/Modal";
import logo from "../image/logo.png";
import "react-toastify/dist/ReactToastify.css";

import "./Login.css";
import LoginAnimation from "./LoginAnimation";

//API handling components
import { BASE_URL, DISABLED_MODULE } from "./../../global";
import { useDispatch } from "react-redux";
import { logOut, logIn } from "./loginSlice";
import moment from "moment";
import { useEffect } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import DeviceRegister from "./deviceRegister";
import { clearLocalStorage } from "../../utils/localstorageClear";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { userDesignation } from "../../constants/masterUserConstants";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: 312,
  bgcolor: "background.paper",
  border: "2px solid cadetblue",
  padding: "20px",
  textAlign: "center",
  borderRadius: "25px",
  display: "flex",
  flexDirection: "column",
};

const data = { userName: "admin", password: "admin" };

const blockTimeConst = 15;
export const ROLES = {
  1: { name: "Calibration Authority", id: 1 },
  2: { name: "Approved Authority", id: 2 },
  3: { name: "Reviewed By", id: 3, client: true },
  4: { name: "Signed By", id: 4, client: true },
  5: { name: "Witnessed By", id: 5, client: true },
};

export const logoutUser = async () => {
  try {
    const res = await axiosWithToken.post(BASE_URL + "logout");

    // Handle success response
    console.log("Logout successful:", res.data);
  } catch (error) {
    // Handle error
    console.error("Logout failed:", error.response?.data || error.message);
  }
};

export const clearAllAppData = async (goOnline) => {
  try {
    // Call API logout first
    await logoutUser();

    // Save required items before clearing
    const sqljs_dbKey = localStorage.getItem("sqljs_db");

    // Clear caches
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));

    clearLocalStorage();

    // ✅ Set a flag before clearing
    localStorage.setItem("appDataCleared", "true");

    if (sqljs_dbKey) {
      goOnline && localStorage.setItem("isOffLine", "false");
      localStorage.setItem("sqljs_db", sqljs_dbKey);
    }

    sessionStorage.clear();

    // Clear cookies
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    });

    // Optional: reload
    // window.location.reload();
  } catch (err) {
    console.error("Error clearing app data:", err);
  }
};

const getStorage = (item, json) => {
  let val = localStorage.getItem(item);
  if (json)
    try {
      val = JSON.parse(val);
    } catch {}
  return val;
};
const setStorage = (item, val, json) => {
  try {
    val = JSON.stringify(val);
  } catch {}
  return localStorage.setItem(item, val);
};

export const useGetRoleInfo = (all, type) => {
  const storage_userType = localStorage.getItem("type");
  const storage_currentRole = getStorage("currentRole", true);
  const storage_roles = (getStorage("roles", true) || []).filter((e) => e);
  const [roles, setRoles] = useState([]);
  const [currentRole, setCurrentRole] = useState({});

  useEffect(() => {
    const role_trace = async () => {
      let tRoles = all
        ? [
            ...(type
              ? Object.values(ROLES).filter((e) =>
                  storage_userType == 3 ? e.client : !e.client,
                )
              : Object.values(ROLES)),
          ]
        : storage_roles.filter((e) =>
            `${storage_userType}` === "3" ? e.client : !e.client,
          );
      let tCurrentRole = { ...storage_currentRole };
      const roleSettings = await axiosWithToken
        .get(
          BASE_URL + `settings?_where=(keyName,like,role~)~and(status,ne,-1)`,
        )
        .then((res) => res.data)
        .catch((err) => {
          console.log("setting fetch error : ", err);
          return false;
        });
      if (roleSettings) {
        let _settingList = {};
        roleSettings.forEach((setting) => {
          if (setting.keyName.startsWith("activeRole")) {
            _settingList[setting.keyName.split("activeRole")[1]] = {
              name: setting.value,
              id: setting.keyName.split("activeRole")[1],
            };
            if (setting.keyName.split("activeRole")[1] == currentRole?.id) {
              tCurrentRole = {
                name: setting.value,
                id: setting.keyName.split("activeRole")[1],
              };
            }
          }
        });
        tRoles = tRoles.map((e) => ({ ...e, ..._settingList[e.id] }) || e);
        tRoles = tRoles.filter((e) => e.name.toLocaleLowerCase() !== "false");
      }
      setCurrentRole(tCurrentRole);
      setStorage("currentRole", tCurrentRole);
      setRoles(tRoles);
      setStorage("roles", tRoles);
    };
    role_trace();
  }, []);

  if (type) return [...roles];
  return {
    roles,
    currentRole,
    setCurrentRole: (newCurrentRole) => {
      setCurrentRole(newCurrentRole);
      setStorage("currentRole", newCurrentRole);
    },
    setRoles: (newRoles) => {
      setRoles(newRoles);
      setStorage("roles", newRoles);
    },
  };
};

//Commented on 27/10/23
//Need to remove after few date, kept to reiew
// export const useGetAllWillBeUsedRoles = () => {
//   const [Roles, setRoles] = useState([...Object.values(ROLES).map((e) => e)]);

//   useEffect(() => {
//     let asyncFn = async () => {
//       let tmp = await axiosToken
//         .get(
//           BASE_URL + `settings?_where=(keyName,like,role~)~and(status,ne,-1)`
//         )
//         .then((res) => res.data)
//         .catch((err) => {
//           console.log("setting fetch error : ", err);
//           return false;
//         });

//       if (tmp) {
//         let _settingList = {};
//         tmp.forEach((setting) => {
//           if (setting.keyName.startsWith("activeRole")) {
//             _settingList[setting.keyName.split("activeRole")[1]] = {
//               name: setting.value,
//               id: setting.keyName.split("activeRole")[1],
//             };
//           }
//         });

//         let tRoles = Roles.map((e) => ({ ...e, ..._settingList[e.id] } || e));
//         tRoles = tRoles.filter((e) => e.name.toLocaleLowerCase() !== "false");
//         setRoles(tRoles);
//       }
//     };
//     asyncFn();
//   }, []);

//   return Roles;
// };

export const addloginEntryInAudit = (
  action,
  userId,
  dateAndTime,
  authToken,
) => {
  const payload = {
    type: "Login History",
    action,
    userId,
    change_date: dateAndTime,
  };

  // ALWAYS return a config object
  const config = { headers: { Authorization: `Bearer ${authToken}` } };
  // RETURN the axios promise
  return axios
    .post(BASE_URL + "audit_log", payload, config)
    .then(() => console.log("Audit log added:", action))
    .catch((err) => console.error("Audit log failed:", action, err));
};

// Shared card header
const CardHeader = ({ overline }) => (
  <>
    <span className="login-card-overline">{overline}</span>
    <h2 className="login-card-title">
      Laboratory
    </h2>
    <p className="login-card-brand-sub">
      Information Management System
    </p>
    <div className="login-card-accent-line"></div>
  </>
);

function Login(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [timer, setTimer] = useState(null);
  const { setCurrentRole, setRoles } = useGetRoleInfo();
  const [isLogin, setIsLogin] = useState(false);
  const [authToken, setAuthToken] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [Otp, setOtp] = useState("");
  const [recoverPassword, setRecoverPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);

  const handleAnimationFinish = () => {
    sessionStorage.setItem("isLoggedIn", "true");
    if (props.setIsLoggedIn) {
      props.setIsLoggedIn(true);
    }
    const userType = localStorage.getItem("type");
    const targetRoute = `${userType}` === "3" ? "/clientDashboard" : "/dashboard";
    window.location.hash = targetRoute;
    window.location.reload();
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const configure = async (
    _id,
    _userName,
    type,
    modules = "",
    clientId = 0,
    companies,
    branch,
    roles,
    designation,
    companyHierarchy,
    editAccess,
    disciplineID,
  ) => {
    clearLocalStorage();
    DISABLED_MODULE?.includes("emailOtpVerification") &&
      sessionStorage.setItem("isLoggedIn", true);
    localStorage.setItem("id", _id);
    localStorage.setItem("clientId", clientId);
    localStorage.setItem("userName", _userName);
    localStorage.setItem("type", type);
    localStorage.setItem("modules", modules);
    localStorage.setItem("validClients", companies);
    localStorage.setItem("branch", branch);
    localStorage.setItem("designationIds", designation);
    localStorage.setItem("companyHierarchy", companyHierarchy);
    localStorage.setItem("editAccess", editAccess);
    localStorage.setItem("disciplineID", disciplineID);

    const firstDesignation = userDesignation?.find(
      (d) => d.id === parseInt((designation || "")?.split(",")[0]),
    );
    localStorage.setItem(
      "designation",
      firstDesignation ? firstDesignation?.name : "",
    );

    let tRoles = (roles?.split(",") || [])
      .filter((e) => (`${type}` === "3" ? ROLES[e].client : !ROLES[e].client))
      .map((e) => ROLES[e]);
    const roleSettings = await axiosWithToken
      .get(BASE_URL + `settings?_where=(keyName,like,role~)~and(status,ne,-1)`)
      .then((res) => res.data)
      .catch((err) => {
        console.log("setting fetch error : ", err);
        return false;
      });
    if (roleSettings) {
      let _settingList = {};
      roleSettings.forEach((setting) => {
        if (setting.keyName.startsWith("activeRole")) {
          _settingList[setting.keyName.split("activeRole")[1]] = {
            name: setting.value,
            id: setting.keyName.split("activeRole")[1],
          };
        }
      });
      tRoles = tRoles.map((e) => ({ ...e, ..._settingList[e.id] }) || e);
      tRoles = tRoles.filter((e) => e.name.toLocaleLowerCase() !== "false");
    }
    let tCurrentRole = tRoles.filter((e) => e.id == tRoles?.[0]?.id)?.[0] || {};
    setCurrentRole(tCurrentRole);
    setRoles(tRoles);
    toast.success("Login Successful!");
  };

  const renderModal = () => {
    return (
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        size="md"
      >
        <Box sx={modalStyle}>
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
            }}
          >
            <span>Kindly contact your admin to reset your credentials!</span>
          </div>
        </Box>
      </Modal>
    );
  };

  const handleVerifyCode = async () => {
    try {
      const { data } = await axiosWithToken.post(
        `${BASE_URL}email/verify-otp`,
        {
          userName,
          userEmail: email,
          otp: verificationCode,
        },
      );

      if (!data?.verification) {
        toast.error("Wrong OTP. Please try again.");
        return;
      }

      // Step 2: Recover password if needed
      if (confirmPassword) {
        try {
          await axiosWithToken.post(`${BASE_URL}recover-password`, {
            confirmPassword,
            emailId: email,
          });
        } catch (error) {
          toast.error("Password recovery failed.");
          console.error("Recover password error:", error);
          return; // Stop further execution
        }
      }

      // Step 3: Continue to login/session handling
      toast.success("Verification successful!");

      if (!authToken) {
        setRecoverPassword(false);
        window.location.reload(true);
        return;
      }

      sessionStorage.setItem("authToken", authToken);
      sessionStorage.setItem("isLoggedIn", true);
      setIsLogin(true);
      setShowAnimation(true);
    } catch (error) {
      toast.error("Invalid OTP. Please try again.");
      console.error("Verification error:", error);
    }
  };

  const sendOtpOnUserEmail = (userName, userEmail, confirmPassword) => {
    axiosWithToken
      .post(`${BASE_URL}email/send-otp`, { userName, userEmail })
      .then(async () => {})
      .catch((error) => {
        console.error("Error sending OTP:", error);
      });
  };

  const handlePasswordSubmit = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error("Both password fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      sendOtpOnUserEmail(userName, email);
      toast.success("Password set! Please verify OTP sent to your email.");
      setIsLogin(true);
      setRecoverPassword(false);
    } catch (error) {
      console.error("Error fetching user email:", error);
      toast.error("Failed to retrieve user email.");
    }
  };

  const handleVerifyEmail = () => {
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email.");
      return;
    }

    axiosWithToken
      .get(`${BASE_URL}usersView?_where=(emailId,eq,${email})`)
      .then((res) => {
        const result = res?.data;
        if (result && result.length > 0) {
          setUserName(result[0]?.userName);
          setIsVerified(true);
        } else {
          toast.error("Email is not registered.");
        }
      })
      .catch((err) => {
        console.error("Error verifying email:", err);
        toast.error("Something went wrong. Please try again.");
      });
  };

  const handleSubmit = async (e) => {
    // Check location access if locationTracking is not in global
    if (!DISABLED_MODULE?.includes("locationTracking")) {
      if (!navigator.geolocation)
        return alert("Geolocation not supported by your browser.");

      try {
        const { state } = await navigator.permissions.query({
          name: "geolocation",
        });
        if (state === "denied")
          return alert(
            "Location access denied. Please allow location access to continue.",
          );
        if (state === "prompt") {
          const granted = await new Promise((resolve) =>
            navigator.geolocation.getCurrentPosition(
              () => resolve(true),
              () => resolve(false),
            ),
          );
          if (!granted)
            return alert("Please allow location access to continue.");
        }
        // if granted, continue...
      } catch {
        const granted = await new Promise((resolve) =>
          navigator.geolocation.getCurrentPosition(
            () => resolve(true),
            () => resolve(false),
          ),
        );
        if (!granted) return alert("Please allow location access to continue.");
      }
    }

    axiosWithToken
      .post(BASE_URL + `login`, {
        userName: userName,
        password: password,
        ...(!DISABLED_MODULE?.includes("UULIMS") && {
          limsId: localStorage.getItem("UULIMS"),
        }),
      })
      .then((res) => {
        const userData = res.data?.user;

        if (userData?.userStatus !== 1) {
          toast.error("User is not Active");
          setTimeout(() => {
            window.location.reload();
          }, 2500);
          return;
        }
        const authToken = res.data.token;
        setAuthToken(authToken);
        const emailId = res?.data?.user?.emailId;
        setEmail(emailId || "");
        if (!emailId && !DISABLED_MODULE?.includes("emailOtpVerification")) {
          toast.error(
            "Email is not available for this user. Please add an email first.",
          );
          return;
        }
        DISABLED_MODULE?.includes("emailOtpVerification") &&
          sessionStorage.setItem("authToken", authToken);
        sessionStorage.setItem("logInUser", res.data?.user?.userName);
        sessionStorage.setItem("chatBoatAPI", BASE_URL);
        !DISABLED_MODULE?.includes("emailOtpVerification") &&
          sendOtpOnUserEmail(res.data?.user?.userName, res.data?.user?.emailId);

        if (res.status === 200) {
          axiosWithToken
            .get(
              BASE_URL +
                `userClientAssign?_where=(userId,eq,${
                  res.data?.user?.id
                })~and(endDate,gt,${moment(new Date()).format("YYYY-MM-DD")})`,
              !DISABLED_MODULE?.includes("emailOtpVerification") && {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
              },
            )
            .then(async (res2) => {
              // console.log("client company mapping : ", res.data);
              setIsLogin(true);
              await configure(
                res.data?.user?.id,
                res.data?.user?.userName,
                res.data?.user?.type,
                res.data?.user?.modules,
                res.data?.user?.clientId,
                res2.data.map((e) => e.companyId).join(","),
                res.data?.user?.branch,
                res.data?.user?.roles || null,
                res.data?.user?.designation,
                res.data?.user?.companyHierarchy,
                res.data?.user?.editAccess,
                res.data?.user?.disciplineID,
              );

              await addloginEntryInAudit(
                "login",
                res.data?.user?.id,
                moment().format("YYYY-MM-DD HH:mm:ss"),
                authToken,
              );

              // if (res.data.length)
              //   dispatch(
              //     logIn({
              //       user: res.data?.user,
              //     })
              //   );
              // else dispatch(logOut());
              // props.setIsLoggedIn(true);
              // if (res.data?.user?.type != 3)
              //  DISABLED_MODULE?.includes("emailOtpVerification") && navigate("/dashboard", { replace: true });
              // else navigate("/clientDashboard", { replace: true });
              if ("caches" in window) {
                caches.keys().then((cacheNames) => {
                  cacheNames.forEach((cacheName) => {
                    caches.delete(cacheName);
                  });
                });
              }
              if (DISABLED_MODULE?.includes("emailOtpVerification")) {
                setShowAnimation(true);
              }
            });
        } else {
          let falseLoginCount = localStorage.getItem("loginCount") || 0;
          setUserName("");
          setPassword("");
          localStorage.setItem("loginCount", Number(falseLoginCount) + 1);
          if (Number(falseLoginCount) === 2) {
            let blockTime = Date.now() + blockTimeConst * 60 * 1000;
            localStorage.setItem("blockTimer", blockTime);
          }
          setIsLoading(false);
          checkTimer();
        }

        setIsLoading(false);
      })
      .catch((error) => {
        const errorMsg = error?.response?.data?.error;
        console.log("errorMsg", errorMsg);

        if (errorMsg?.toLowerCase().includes("device not register")) {
          // Device not registered
          toast.error("Your device is not registered contact to BFI Team.");
        } else if (errorMsg?.toLowerCase().includes("already logged in")) {
          // ✅ Already logged in on another device
          toast.error(
            "Already logged in on another device. Please logout first.",
          );
          setIsLoading(false);
        } else {
          // Wrong username/password
          toast.error("Incorrect Username / password");
          setTimeout(() => {
            window.location.reload();
          }, 700);
          setError(error.response.data.error);
          let falseLoginCount = localStorage.getItem("loginCount") || 0;
          localStorage.setItem("loginCount", Number(falseLoginCount) + 1);
          if (Number(falseLoginCount) === 2) {
            let blockTime = Date.now() + blockTimeConst * 60 * 1000;
            localStorage.setItem("blockTimer", blockTime);
          }
          setIsLoading(false);
          checkTimer();
        }
      });
  };

  const checkTimer = () => {
    let blockCount = Number(localStorage.getItem("loginCount")) || 0;
    if (blockCount > 2) {
      let blockTime =
        ((Number(localStorage.getItem("blockTimer")) || 0) - Date.now()) / 1000;
      blockTime = blockTime > 0 ? blockTime : 0;
      if (blockTime && !timer)
        setInterval(() => {
          checkTimer();
        }, 1000);
      if (blockTime)
        setError(
          `Please try again after ${parseInt(
            `${blockTime / 60}`,
          )} minutes and ${parseInt(`${blockTime % 60}`)} seconds ${
            blockCount < 3 ? `(${3 - blockCount} tries remaining)` : ""
          }`,
        );
      else {
        localStorage.setItem("loginCount", 0);
        localStorage.setItem("blockTimer", -1);
        if (timer) clearInterval(timer);
        setError("");
      }
    } else if (blockCount > 0) {
      setError(
        `Incorrect Username / password \n  ${
          blockCount < 3 ? `(${3 - blockCount} tries remaining)` : ""
        }`,
      );
    } else setError("");
  };

  useEffect(() => {
    checkTimer();
    return () => {
      if (timer) clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    const isDataCleared = localStorage.getItem("appDataCleared");
    if (!isDataCleared) {
      clearAllAppData();
    }
  }, []);

  useEffect(() => {
    const prevBody = document.body.style.overflow;
    const prevHtml = document.documentElement.style.overflow;
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevBody;
      document.documentElement.style.overflow = prevHtml;
    };
  }, []);

  return (
    <>
      {showAnimation && <LoginAnimation onFinish={handleAnimationFinish} />}
      {!showAnimation && (
        <div className="login-portal-wrapper">
          {/* Top Brand Lockup (Logo + Title) */}
          <div className="login-top-bar">
            <div className="login-brand-header">
              <div className="login-logo-box">
                <img src={logo} alt="logo" />
              </div>
              <div className="login-brand-text">
                <span className="login-brand-title">
                  Laboratory
                </span>
                <span className="login-brand-sub">
                  Information Management System
                </span>
              </div>
            </div>
          </div>

          {/* Center Main Area: Left Hero + Right Vertically Centered Card */}
          <div className="login-main-container">
            <div className="login-left-section">
              <div className="login-accent-bar"></div>
              <h1 className="login-hero-headline">
                Smart Software For Modern<br />Calibration Laboratories
              </h1>
              <p className="login-hero-subtext">
                Streamline Your Laboratory Operations, Ensure Accuracy,
                <br />
                Maintain Compliance, And Drive Efficiency.
              </p>

              <div className="login-feature-badges">
                <div className="login-badge-item">
                  <div className="login-badge-icon">
                    <SettingsOutlinedIcon sx={{ fontSize: "22px" }} />
                  </div>
                  <span className="login-badge-label">
                    Manage<br />Calibrations
                  </span>
                </div>

                <div className="login-badge-item">
                  <div className="login-badge-icon">
                    <AssignmentTurnedInOutlinedIcon sx={{ fontSize: "22px" }} />
                  </div>
                  <span className="login-badge-label">
                    Maintain<br />Compliance
                  </span>
                </div>

                <div className="login-badge-item">
                  <div className="login-badge-icon">
                    <TrendingUpIcon sx={{ fontSize: "22px" }} />
                  </div>
                  <span className="login-badge-label">
                    Improve<br />Efficiency
                  </span>
                </div>

                <div className="login-badge-item">
                  <div className="login-badge-icon">
                    <ShieldOutlinedIcon sx={{ fontSize: "22px" }} />
                  </div>
                  <span className="login-badge-label">
                    Trusted<br />& Secure
                  </span>
                </div>
              </div>
            </div>

            {/* Right Side: Vertically Centered Floating Login Card */}
            <div className="login-right-section">
              <div className="login-card-container">
                {recoverPassword ? (
                  // ✅ Recover Password UI
                  <div className="login-form-inner validate-form">
                    <CardHeader overline="ACCOUNT RECOVERY" />
                    <h3 className="login-card-welcome">Recover Password</h3>
                    <p className="login-card-subtitle">
                      Set a new password for your account
                    </p>

                    {/* Email field */}
                    <div
                      className="wrap-input100 validate-input input-group-focus"
                      style={{ position: "relative" }}
                    >
                      <label className="login-label">Email Address</label>
                      <span className="symbol-input100">
                        <PersonOutlineIcon style={{ fontSize: "20px" }} />
                      </span>
                      <input
                        className="input100"
                        type="email"
                        name="email"
                        placeholder="Enter your email"
                        value={email || ""}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <span className="focus-input100"></span>
                    </div>

                    {/* Password Fields - Show only after verification */}
                    {isVerified && (
                      <>
                        <div
                          className="wrap-input100 validate-input input-group-focus"
                          style={{ position: "relative" }}
                        >
                          <label className="login-label">New Password</label>
                          <span className="symbol-input100">
                            <LockOutlinedIcon style={{ fontSize: "20px" }} />
                          </span>
                          <input
                            className="input100"
                            type={showPassword ? "text" : "password"}
                            name="newPassword"
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                          />
                          <span className="focus-input100"></span>
                          <span
                            className="symbol-input100-right"
                            onClick={() => setShowPassword((prev) => !prev)}
                          >
                            {showPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </span>
                        </div>

                        <div
                          className="wrap-input100 validate-input input-group-focus"
                          style={{ position: "relative" }}
                        >
                          <label className="login-label">Confirm Password</label>
                          <span className="symbol-input100">
                            <LockOutlinedIcon style={{ fontSize: "20px" }} />
                          </span>
                          <input
                            className="input100"
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          />
                          <span className="focus-input100"></span>
                          <span
                            className="symbol-input100-right"
                            onClick={() => setShowConfirmPassword((prev) => !prev)}
                          >
                            {showConfirmPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </span>
                        </div>
                      </>
                    )}

                    {/* Button — Next or Continue */}
                    <div className="container-login100-form-btn">
                      {!isVerified ? (
                        <button
                          className="login-submit-btn"
                          onClick={handleVerifyEmail}
                          disabled={!email}
                        >
                          Next
                        </button>
                      ) : (
                        <button
                          className="login-submit-btn"
                          onClick={handlePasswordSubmit}
                          disabled={
                            !newPassword ||
                            !confirmPassword ||
                            newPassword !== confirmPassword
                          }
                        >
                          Continue
                        </button>
                      )}
                    </div>

                    <div
                      className="text-center p-t-12"
                      style={{ marginTop: "14px" }}
                    >
                      <span className="txt1">Remember it? </span>
                      <button
                        className="login-back-link"
                        onClick={() => setRecoverPassword(false)}
                      >
                        Back to Login
                      </button>
                    </div>
                  </div>
                ) : !DISABLED_MODULE?.includes("emailOtpVerification") &&
                  isLogin ? (
                  <div className="login-form-inner validate-form">
                    <CardHeader overline="TWO-FACTOR AUTH" />
                    <h3 className="login-card-welcome">Verify it’s you</h3>

                    <p style={{ textAlign: "center", marginBottom: "20px", color: "#64748b", fontSize: "14px" }}>
                      A verification code has been sent to your email address ending
                      with{" "}
                      <strong style={{ color: "#0f172a" }}>
                        {email
                          ? `${email.slice(0, 3)}***@${email.split("@")[1]}`
                          : ""}
                      </strong>
                      .
                    </p>

                    <div
                      className="wrap-input100 validate-input"
                      data-validate="6-digit code is required"
                    >
                      <input
                        className="input100"
                        type="text"
                        name="code"
                        maxLength={6}
                        placeholder="6-digit code"
                        value={verificationCode}
                        onChange={(e) => setVerificationCode(e.target.value)}
                        style={{ textAlign: "center", letterSpacing: "4px", fontSize: "18px", fontWeight: 600 }}
                      />
                      <span className="focus-input100"></span>
                    </div>

                    <div className="container-login100-form-btn">
                      <button
                        className="login-submit-btn"
                        onClick={handleVerifyCode}
                      >
                        Verify Code
                      </button>
                    </div>

                    <div className="text-center p-t-12" style={{ marginTop: "14px" }}>
                      <span className="txt1">Can't verify? </span>
                      <button
                        className="login-back-link"
                        onClick={() => setRecoverPassword(true)}
                      >
                        Recover your account.
                      </button>
                    </div>

                    <p
                      style={{
                        fontSize: "12px",
                        textAlign: "center",
                        marginTop: "12px",
                        color: "#94a3b8"
                      }}
                    >
                      <strong>Note:</strong> All of these verification methods will
                      be removed after successful recovery.
                    </p>
                  </div>
                ) : (
                  <div className="login-form-inner validate-form">
                    <CardHeader overline="WELCOME TO" />

                    <h3 className="login-card-welcome">Welcome back</h3>
                    <p className="login-card-subtitle">
                      Please sign in to continue to your account.
                    </p>

                    <div
                      className="wrap-input100 validate-input input-group-focus"
                      data-validate="Valid email is required: ex@abc.xyz"
                      style={{ position: "relative" }}
                    >
                      <label className="login-label">Username</label>
                      <span className="symbol-input100">
                        <PersonOutlineIcon style={{ fontSize: "20px" }} />
                      </span>
                      <input
                        className="input100"
                        type="text"
                        name="email"
                        placeholder="Enter your username"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        disabled={
                          Number(localStorage.getItem("loginCount") || 0) === 3
                        }
                      />
                      <span className="focus-input100"></span>
                    </div>

                    <div
                      className="wrap-input100 validate-input input-group-focus"
                      data-validate="Password is required"
                      style={{ position: "relative" }}
                    >
                      <label className="login-label">Password</label>
                      <span className="symbol-input100">
                        <LockOutlinedIcon style={{ fontSize: "20px" }} />
                      </span>
                      <input
                        className="input100"
                        type={showPassword ? "text" : "password"}
                        name="pass"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={
                          Number(localStorage.getItem("loginCount") || 0) === 3
                        }
                      />
                      <span
                        className="symbol-input100-right"
                        onClick={() => setShowPassword((prev) => !prev)}
                        style={{ cursor: "pointer" }}
                      >
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </span>
                    </div>

                    <div className="login-forgot-row">
                      <button
                        type="button"
                        className="login-forgot-btn"
                        onClick={() => setRecoverPassword(true)}
                      >
                        Forgot Password?
                      </button>
                    </div>

                    {error && (
                      <span className="login-error-text">
                        {error}
                      </span>
                    )}

                    <div className="container-login100-form-btn">
                      <button
                        className="login-submit-btn"
                        onClick={() => {
                          setIsLoading(true);
                          handleSubmit();
                        }}
                        disabled={
                          isLoading ||
                          localStorage.getItem("blockTimer") > Date.now() ||
                          (Number(localStorage.getItem("loginCount")) || 0) === 3
                        }
                      >
                        <span>Sign In</span>
                        <ArrowForwardIcon sx={{ fontSize: "19px", ml: 1 }} />
                      </button>
                    </div>

                    <div className="login-divider-row">
                      <span className="login-divider-line"></span>
                      <span className="login-divider-text">or</span>
                      <span className="login-divider-line"></span>
                    </div>

                    <div className="login-support-row">
                      <span className="txt1">Need help? </span>
                      <a
                        href="mailto:Info@bfiinfotech.co.in"
                        className="login-support-link"
                      >
                        Contact Support
                      </a>
                    </div>

                    <div className="login-secure-badge">
                      <ShieldOutlinedIcon sx={{ fontSize: "16px", color: "#64748b", mr: 0.8 }} />
                      <span>Secure access for calibrated workflows</span>
                    </div>

                    {!DISABLED_MODULE?.includes("UULIMS") && (
                      <div className="login-device-register-wrap">
                        <DeviceRegister />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {renderModal()}
    </>
  );
}

export default Login;
